import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" };
const _hoisted_2 = { class: "card-head box-shadow bg-white p-15 p-sm-20 p-md-25" };
const _hoisted_3 = { class: "row align-items-center g-3" };
const _hoisted_4 = { class: "col-md-4" };
const _hoisted_5 = { class: "mb-0 fw-bold d-flex align-items-center" };
const _hoisted_6 = { class: "col-md-8" };
const _hoisted_7 = { class: "d-flex flex-wrap align-items-center justify-content-md-end gap-3" };
const _hoisted_8 = { class: "search-box" };
const _hoisted_9 = { class: "input-group input-group-sm" };
const _hoisted_10 = ["placeholder"];
const _hoisted_11 = {
    class: "restaurant-selector",
    style: { "min-width": "180px" }
};
const _hoisted_12 = { value: "all" };
const _hoisted_13 = ["value"];
const _hoisted_14 = { class: "d-flex align-items-center gap-2" };
const _hoisted_15 = ["disabled"];
const _hoisted_16 = { class: "card-body p-15 p-sm-20 p-md-25" };
const _hoisted_17 = { class: "table-responsive" };
const _hoisted_18 = { class: "table text-nowrap align-middle mb-0" };
const _hoisted_19 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
};
const _hoisted_20 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-center"
};
const _hoisted_21 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-center"
};
const _hoisted_22 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-center"
};
const _hoisted_23 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_24 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
};
const _hoisted_25 = { key: 0 };
const _hoisted_26 = { key: 1 };
const _hoisted_27 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" };
const _hoisted_28 = { class: "d-flex align-items-center" };
const _hoisted_29 = { class: "flex-shrink-0" };
const _hoisted_30 = {
    class: "rounded-circle bg-light d-flex align-items-center justify-content-center text-primary fw-bold",
    style: { "width": "36px", "height": "36px" }
};
const _hoisted_31 = { class: "flex-grow-1 ms-10" };
const _hoisted_32 = { class: "mb-0 fs-14" };
const _hoisted_33 = { class: "text-muted fs-12" };
const _hoisted_34 = { class: "shadow-none text-center fw-bold text-success fs-14" };
const _hoisted_35 = { class: "shadow-none text-center fw-bold text-danger fs-14" };
const _hoisted_36 = { class: "shadow-none text-center" };
const _hoisted_37 = { class: "badge bg-primary-subtle text-primary border-primary-subtle fs-12" };
const _hoisted_38 = { class: "shadow-none fs-13 text-muted" };
const _hoisted_39 = { class: "shadow-none text-end pe-0" };
const _hoisted_40 = ["onClick"];
const _hoisted_41 = {
    key: 0,
    class: "d-lg-flex align-items-center justify-content-between mt-20"
};
const _hoisted_42 = { class: "mb-0 text-muted fs-13" };
const _hoisted_43 = { "aria-label": "Page navigation" };
const _hoisted_44 = { class: "pagination mb-0" };
const _hoisted_45 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_VabeneLoyaltyCustomerDetail = _resolveComponent("VabeneLoyaltyCustomerDetail");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("h5", _hoisted_5, [
                        _cache[13] || (_cache[13] = _createElementVNode("i", { class: "flaticon-star me-2 text-primary" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('loyalty.reportTitle') || "Rapport Fidélité Clients"), 1)
                    ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "input-group-text bg-white border-end-0" }, [
                                    _createElementVNode("i", { class: "fas fa-search text-muted" })
                                ], -1)),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control border-start-0 shadow-none",
                                    placeholder: _ctx.$t('common.search') || 'Rechercher un client...',
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.filters.search) = $event)),
                                    onInput: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.debounceSearch && _ctx.debounceSearch(...args)))
                                }, null, 40, _hoisted_10), [
                                    [_vModelText, _ctx.filters.search]
                                ])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                            _withDirectives(_createElementVNode("select", {
                                class: "form-select form-select-sm shadow-none",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.filters.restaurantId) = $event)),
                                onChange: _cache[3] || (_cache[3] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleFilterChange && _ctx.handleFilterChange(...args)))
                            }, [
                                _createElementVNode("option", _hoisted_12, _toDisplayString(_ctx.$t('lists.allRestaurants')), 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.restaurants, (res) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                        key: res.id,
                                        value: res.id
                                    }, _toDisplayString(res.name), 9, _hoisted_13));
                                }), 128))
                            ], 544), [
                                [_vModelSelect, _ctx.filters.restaurantId]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                            _withDirectives(_createElementVNode("input", {
                                type: "date",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.filters.startDate) = $event)),
                                class: "form-control form-control-sm",
                                onChange: _cache[5] || (_cache[5] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleFilterChange && _ctx.handleFilterChange(...args)))
                            }, null, 544), [
                                [_vModelText, _ctx.filters.startDate]
                            ]),
                            _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-muted fs-12" }, "–", -1)),
                            _withDirectives(_createElementVNode("input", {
                                type: "date",
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.filters.endDate) = $event)),
                                class: "form-control form-control-sm",
                                onChange: _cache[7] || (_cache[7] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleFilterChange && _ctx.handleFilterChange(...args)))
                            }, null, 544), [
                                [_vModelText, _ctx.filters.endDate]
                            ])
                        ]),
                        _createElementVNode("button", {
                            class: "btn btn-primary d-flex align-items-center gap-2 btn-sm",
                            onClick: _cache[8] || (_cache[8] = ($event) => (_ctx.fetchCustomers(1))),
                            disabled: _ctx.loading
                        }, [
                            _createElementVNode("i", {
                                class: _normalizeClass(["fas fa-sync-alt", { 'fa-spin': _ctx.loading }])
                            }, null, 2),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('common.refresh')), 1)
                        ], 8, _hoisted_15)
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
                _createElementVNode("table", _hoisted_18, [
                    _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                            _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.$t('loyalty.reportCustomer')), 1),
                            _createElementVNode("th", _hoisted_20, _toDisplayString(_ctx.$t('loyalty.earn')), 1),
                            _createElementVNode("th", _hoisted_21, _toDisplayString(_ctx.$t('loyalty.spend')), 1),
                            _createElementVNode("th", _hoisted_22, _toDisplayString(_ctx.$t('loyalty.reportBalance')), 1),
                            _createElementVNode("th", _hoisted_23, _toDisplayString(_ctx.$t('loyalty.reportLastActivity') || _ctx.$t('lists.updatedAt')), 1),
                            _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.$t('lists.actions')), 1)
                        ])
                    ]),
                    _createElementVNode("tbody", null, [
                        (_ctx.loading)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_25, [...(_cache[16] || (_cache[16] = [
                                    _createElementVNode("td", {
                                        colspan: "6",
                                        class: "text-center py-5"
                                    }, [
                                        _createElementVNode("div", {
                                            class: "spinner-border text-primary",
                                            role: "status"
                                        }),
                                        _createElementVNode("p", { class: "mt-2 text-muted" }, "Chargement des clients...")
                                    ], -1)
                                ]))]))
                            : (_ctx.customers.length === 0)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_26, [...(_cache[17] || (_cache[17] = [
                                        _createElementVNode("td", {
                                            colspan: "6",
                                            class: "text-center py-5 text-muted italic"
                                        }, " Aucun client avec activité trouvé pour cette période. ", -1)
                                    ]))]))
                                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.customers, (c) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: c.userId
                                    }, [
                                        _createElementVNode("td", _hoisted_27, [
                                            _createElementVNode("div", _hoisted_28, [
                                                _createElementVNode("div", _hoisted_29, [
                                                    _createElementVNode("div", _hoisted_30, _toDisplayString((c.firstName || '?').charAt(0).toUpperCase()), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_31, [
                                                    _createElementVNode("h6", _hoisted_32, _toDisplayString(c.firstName) + " " + _toDisplayString(c.lastName), 1),
                                                    _createElementVNode("span", _hoisted_33, _toDisplayString(c.email), 1)
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("td", _hoisted_34, " +" + _toDisplayString(c.totalEarned || 0), 1),
                                        _createElementVNode("td", _hoisted_35, " -" + _toDisplayString(c.totalSpent || 0), 1),
                                        _createElementVNode("td", _hoisted_36, [
                                            _createElementVNode("span", _hoisted_37, _toDisplayString(c.currentBalance || 0) + " pts ", 1)
                                        ]),
                                        _createElementVNode("td", _hoisted_38, _toDisplayString(_ctx.formatDate(c.lastActivity)), 1),
                                        _createElementVNode("td", _hoisted_39, [
                                            _createElementVNode("button", {
                                                class: "btn btn-sm btn-outline-primary shadow-none",
                                                onClick: ($event) => (_ctx.showDetails(c))
                                            }, [...(_cache[18] || (_cache[18] = [
                                                    _createElementVNode("i", { class: "fas fa-history me-1" }, null, -1),
                                                    _createTextVNode(" Détails ", -1)
                                                ]))], 8, _hoisted_40)
                                        ])
                                    ]));
                                }), 128))
                    ])
                ])
            ]),
            (_ctx.pagination.totalPages > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    _createElementVNode("p", _hoisted_42, " Affichage de " + _toDisplayString(_ctx.customers.length) + " clients sur " + _toDisplayString(_ctx.pagination.total), 1),
                    _createElementVNode("nav", _hoisted_43, [
                        _createElementVNode("ul", _hoisted_44, [
                            _createElementVNode("li", {
                                class: _normalizeClass(["page-item", { disabled: _ctx.pagination.page === 1 }])
                            }, [
                                _createElementVNode("a", {
                                    class: "page-link shadow-none",
                                    href: "#",
                                    onClick: _cache[9] || (_cache[9] = _withModifiers(($event) => (_ctx.changePage(_ctx.pagination.page - 1)), ["prevent"]))
                                }, [...(_cache[19] || (_cache[19] = [
                                        _createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1)
                                    ]))])
                            ], 2),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagination.totalPages, (p) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    key: p,
                                    class: _normalizeClass(["page-item", { active: p === _ctx.pagination.page }])
                                }, [
                                    _createElementVNode("a", {
                                        class: "page-link shadow-none",
                                        href: "#",
                                        onClick: _withModifiers(($event) => (_ctx.changePage(p)), ["prevent"])
                                    }, _toDisplayString(p), 9, _hoisted_45)
                                ], 2));
                            }), 128)),
                            _createElementVNode("li", {
                                class: _normalizeClass(["page-item", { disabled: _ctx.pagination.page === _ctx.pagination.totalPages }])
                            }, [
                                _createElementVNode("a", {
                                    class: "page-link shadow-none",
                                    href: "#",
                                    onClick: _cache[10] || (_cache[10] = _withModifiers(($event) => (_ctx.changePage(_ctx.pagination.page + 1)), ["prevent"]))
                                }, [...(_cache[20] || (_cache[20] = [
                                        _createElementVNode("i", { class: "fas fa-chevron-right" }, null, -1)
                                    ]))])
                            ], 2)
                        ])
                    ])
                ]))
                : _createCommentVNode("", true)
        ]),
        _createVNode(_component_VabeneLoyaltyCustomerDetail, {
            visible: _ctx.detailPanel.visible,
            userId: _ctx.detailPanel.user?.userId,
            customerName: _ctx.detailPanel.user ? `${_ctx.detailPanel.user.firstName} ${_ctx.detailPanel.user.lastName}` : '',
            currentBalance: _ctx.detailPanel.user?.currentBalance,
            totalEarned: _ctx.detailPanel.user?.totalEarned,
            franchiseId: _ctx.filters.franchiseId,
            restaurantId: _ctx.filters.restaurantId,
            startDate: _ctx.filters.startDate,
            endDate: _ctx.filters.endDate,
            onClose: _cache[11] || (_cache[11] = ($event) => (_ctx.detailPanel.visible = false)),
            onRefresh: _cache[12] || (_cache[12] = ($event) => (_ctx.fetchCustomers(_ctx.pagination.page)))
        }, null, 8, ["visible", "userId", "customerName", "currentBalance", "totalEarned", "franchiseId", "restaurantId", "startDate", "endDate"])
    ]));
}
